<template>
    <div class="flex flex-col">
        <div v-if="errorMessage" class="mb-5 bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md shadow-md">
            <div class="flex">
                <div class="ml-3">
                    <p class="text-sm">{{ errorMessage }}</p>
                </div>
            </div>
        </div>
        <modal v-if="showEditModal" modal-container-class="w-1/2 relative">
            <div slot="header" class="w-full px-32">
                <div class="flex flex-col w-full">
                    <div>
                        <h2 class="text-lg font-bold">{{ form.record.user.full_name_reverse }}</h2>
                    </div>
                    <div v-if="form.record.leave == 'WORK'" class="flex justify-between">
                        <div class="flex">
                            <span>{{ formatToHours(workHours[form.record_index].start_time) }}</span>
                            <span>&nbsp;do&nbsp;</span>
                            <span>{{ formatToHours(workHours[form.record_index].end_time) }}</span>
                        </div>
                        <div>
                            <span>{{ workHours[form.record_index].total_time }}h</span>
                        </div>
                    </div>
                    <hr class="mt-4" />
                </div>
            </div>
            <div slot="body" class="px-32 w-full">
              <div class="w-full">
                    <div class="form-group">
                        <label for="leave">Status</label>
                        <v-select
                            class="form-select"
                            id="leave"
                            v-model="form.record_status"
                            @input="handleChosenStatus"
                            :options="statusList"
                            :clearable="false"
                            label="display"
                        ></v-select>
                    </div>
                </div>
                <div class="w-full mt-4" v-if="form.record_status && form.record_status.name == 'WORK'">
                    <div class="form-group">
                        <label for="project">Radni nalog</label>
                        <v-select
                            class="form-select"
                            id="project"
                            v-model="form.project"
                            @input="handleChosenStatus"
                            :options="projectsList"
                            :clearable="false"
                            label="name"
                        ></v-select>
                    </div>
                    <span class="error-message" v-if="projectEmptyError" v-text="projectEmptyError"></span>
                </div>
                <div class="flex flex-col w-full mt-4" v-if="form.record_status && form.record_status.name == 'WORK'">
                    <div>
                        <h2 class="text-lg font-bold">Uredi vrijeme</h2>
                    </div>
                    <div class="flex mt-6">
                        <div class="w-1/3 pr-2">
                            <label for="start_date_edit">Vrijeme od</label>
                            <vue-ctk-date-time-picker
                                class="form-control only-time"
                                :class="{ _error: validationErrors.start_time }"
                                id="start_date_edit"
                                v-model="form.record.start_time"
                                label="Odaberite vrijeme"
                                locale="hr"
                                :disabled="form.record_status ? form.record_status.name != 'WORK' : null"
                                format="YYYY-MM-DD HH:mm"
                                formatted="YYYY-MM-DD HH:mm:ss"
                                :minute-interval="30"
                                :noClearButton="true"
                            ></vue-ctk-date-time-picker>
                            <span
                                class="error-message"
                                v-if="validationErrors.start_time"
                                v-text="validationErrors.start_time[0]"
                            ></span>
                        </div>
                        <div class="w-1/3 pl-2">
                            <label for="end_date_edit">Vrijeme do</label>
                            <vue-ctk-date-time-picker
                                class="form-control only-time"
                                :class="{ _error: validationErrors.end_time }"
                                id="end_date_edit"
                                v-model="form.record.end_time"
                                label="Odaberite vrijeme"
                                locale="hr"
                                :disabled="form.record_status ? form.record_status.name != 'WORK' : null"
                                format="YYYY-MM-DD HH:mm"
                                formatted="YYYY-MM-DD HH:mm:ss"
                                :minute-interval="30"
                                :noClearButton="true"
                            ></vue-ctk-date-time-picker>
                            <span
                                class="error-message"
                                v-if="validationErrors.end_time"
                                v-text="validationErrors.end_time[0]"
                            ></span>
                        </div>
                        <div class="w-1/3 pl-2">
                            <label for="total_time_edit">Ukupno</label>
                            <vue-ctk-date-time-picker
                                class="form-control"
                                :class="{ _error: validationErrors.total_time }"
                                id="total_time_edit"
                                v-model="form.record.total_time"
                                label="Odaberite vrijeme"
                                locale="hr"
                                :disabled="form.record_status ? form.record_status.name != 'WORK' : null"
                                :onlyTime="true"
                                format="HH:mm"
                                formatted="HH:mm"
                                :minute-interval="30"
                                :noClearButton="true"
                            ></vue-ctk-date-time-picker>
                            <span
                                class="error-message"
                                v-if="validationErrors.total_time"
                                v-text="validationErrors.total_time[0]"
                            ></span>
                        </div>
                    </div>
                    <hr class="my-4" />
                </div>
                <div class="w-full" v-if="form.record_status && form.record_status.name == 'SICK'">
                    <div class="form-group mt-4">
                        <label >
                            <span>Ozljeda na radu</span>
                            <input type="checkbox" v-model="form.has_work_injury" class="form-checkbox" value="1">
                        </label>
                    </div>
                </div>
                <div class="form-group mt-4">
                    <label for="remark">Napomena</label>
                    <textarea
                        class="p-4 mt-2 border rounded border-black border-opacity-10 text-sm font-heading w-full"
                        id="remark"
                        v-model="form.record.remark"
                    ></textarea>
                </div>
            </div>
            <div slot="footer">
                <button class="btn primary" @click="checkRecordStatus">Spremi</button>
                <button class="btn danger" @click="toggleRemoveRecordPopup(true)">Ukloni</button>
            </div>
            <div class="absolute top-0 right-0" slot="absolute">
                <button @click="closeEditForm">
                    <img class="w-6 m-4" src="/svg/close.svg" alt="close" />
                </button>
            </div>
        </modal>

        <modal v-if="logModalOpen" modal-container-class="w-1/2 relative max-h-screen overflow-auto">
            <div slot="header" class="w-full px-8">
                <div class="flex flex-col w-full">
                    <div>
                        <h2 class="text-lg font-bold">Logovi za {{ logData.user.full_name_reverse }} - {{ logData.project ? logData.project.code : 'n/a' }}</h2>
                    </div>
                    <hr class="mt-4" />
                </div>
            </div>

            <div slot="body" class="px-8 w-full flex flex-col items-start" v-if="logData.activities && logData.activities.length > 0">
                <div class="w-full border-b py-2 flex" v-for="(activity, key) in logData.activities" :key="key">
                    <div class="w-1/4 px-2 border-r" v-text="descriptionSwitch(activity.description)"></div>
                    <div class="w-1/4 px-2 border-r" v-text="activity.causer ? activity.causer.full_name : 'Neaktivan korisnik'"></div>
                    <div class="w-1/4 px-2 border-r flex flex-col">
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('date')"
                            v-text="'Datum: ' + activity.properties.attributes.date"
                        ></span>
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('project_id')"
                            v-text="'Projekt ID: ' + activity.properties.attributes.project_id"
                        ></span>
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('confirmed')"
                            v-text="'Potvrđeno: ' + (activity.properties.attributes.confirmed ? 'Da' : 'Ne')"
                        ></span>
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('leave')"
                            v-text="'Status: ' + (activity.properties.attributes.leave ? statusList.find(status => status.name == activity.properties.attributes.leave).display : activity.properties.attributes.leave)"
                        ></span>
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('start_time')"
                            v-text="'Dolazak: ' + activity.properties.attributes.start_time"
                        ></span>
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('end_time')"
                            v-text="'Odlazak: ' + activity.properties.attributes.end_time"
                        ></span>
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('total_time')"
                            v-text="'Ukupno: ' + activity.properties.attributes.total_time"
                        ></span>
                        <span
                            class="block mb-2"
                            v-if="activity.properties.attributes.hasOwnProperty('remark')"
                            v-text="'Napomena: ' + activity.properties.attributes.remark"
                        ></span>
                    </div>
                    <div class="w-1/4 px-2 border-r" v-text="parseDate(activity.created_at)"></div>
                </div>
            </div>
            <div slot="body" class="px-32 w-full flex flex-col items-start" v-else>
                Nema spremljenih logova
            </div>

            <div slot="footer">
                <button class="btn primary" @click="hideLogModal">Zatvori</button>
            </div>

            <div class="absolute top-0 right-0" slot="absolute">
                <button @click="hideLogModal">
                    <img class="w-6 m-4" src="/svg/close.svg" alt="close" />
                </button>
            </div>
        </modal>

        <modal v-if="removeRecordPopup">
          <div slot="header" class="w-full px-8">
            <div class="flex flex-col w-full">
              <div>
                <h2 class="text-lg font-bold">Jeste li sigurni da želite ukloniti sate za korisnika - {{ form.record.user.full_name_reverse }}</h2>
              </div>
              <hr class="mt-4" />
            </div>
          </div>

          <div slot="body">
            &nbsp;
          </div>

          <div slot="footer">
            <button class="btn primary" @click="toggleRemoveRecordPopup(false)">Ne</button>
            <button class="btn danger" @click="removeRecord">Da</button>
          </div>

          <div class="absolute top-0 right-0" slot="absolute">
            <button @click="toggleRemoveRecordPopup(false)">
              <img class="w-6 m-4" src="/svg/close.svg" alt="close" />
            </button>
          </div>
        </modal>

        <div class="flex w-full ml-8">
            <div class="max-w-xs">
                <vue-ctk-date-time-picker
                    class="form-control"
                    :class="{ _error: validationErrors.noDate }"
                    id="picked_date"
                    v-model="pickedDate"
                    label="Odaberite datum"
                    locale="hr"
                    format="YYYY-MM-DD"
                    formatted="DD.MM.YYYY."
                    :only-date="true"
                    :range="true"
                    :max-date="maxDate"
                    :noShortcuts="true"
                ></vue-ctk-date-time-picker>
                <span
                    class="error-message"
                    v-if="validationErrors.noDate"
                    v-text="validationErrors.noDate[0]"
                ></span>
            </div>
            <div class="ml-8">
                <button class="btn primary" @click="showDataForDate">Prikaži</button>
            </div>
        </div>

        <hr class="my-12" />
        <div v-if="showCard" class="card mx-8">
            <div class="card-body flex flex-col">
                <div class="card-headers flex">
                    <!-- <div class="pt-6 px-16 border-b border-card-border border-opacity-10">
                        <h2 class="text-lg font-bold">Datum</h2>
                    </div> -->
                    <div class="w-1/4 pt-6 px-16 border-b border-card-border border-opacity-10">
                        <h2 class="text-lg font-bold">Osoba</h2>
                    </div>
                    <div
                        class="w-1/4 pt-6 px-16 border-b border-l border-card-border border-opacity-10"
                    >
                        <h2 class="text-lg font-bold">Radni nalog</h2>
                    </div>
                    <div
                        class="flex flex-col flex-grow pt-6 border-b border-l border-card-border border-opacity-10"
                    >
                        <div class="w-full pl-16">
                            <h2 class="text-lg font-bold">Vrijeme</h2>
                        </div>
                        <div class="w-full flex justify-center items-start">
                            <div class="w-1/4 font-light text-xs flex items-center h-full pl-4">
                                <span>Datum</span>
                            </div>
                            <div class="w-1/3 font-light text-xs flex items-center h-full pl-16">
                                <span>Dolazak</span>
                            </div>
                            <div class="w-1/3 font-light text-xs flex items-center h-full pl-16">
                                <span>Odlazak</span>
                            </div>
                            <div class="w-1/3 font-light text-xs flex items-center h-full pl-16">
                                <span>Ukupno</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex flex-col w-32 pt-6 px-6 border-b border-l border-card-border border-opacity-10"
                    >
                        <div class="w-full flex justify-center">
                            <h2 class="text-lg font-bold">Potvrdi</h2>
                        </div>
                        <div class="w-full flex justify-center items-start">
                            <button
                                v-if="allSelected"
                                class="font-light text-primary underline text-xs"
                                @click="selectAll"
                                :disabled="!!monthLocked"
                            >Označi sve</button>
                            <button
                                v-else
                                class="font-light text-primary underline text-xs"
                                @click="unselectAll"
                                :disabled="!!monthLocked"
                            >Odznači sve</button>
                        </div>
                    </div>
                    <div
                        class="w-16 pt-6 px-2 border-b border-l border-card-border border-opacity-10"
                    >
                        <h2 class="text-lg font-bold text-center">Log</h2>
                    </div>
                </div>
                <div
                    v-for="(record, index) in workHours"
                    :key="'record-' + index"
                    class="card-row flex"
                    :id="index"
                >
                    <!-- <div class="py-4 px-16 border-b border-card-border border-opacity-10 flex items-center">
                        <h2 class="text-lg">{{ record.date }}</h2>
                    </div> -->
                    <div class="w-1/4 py-4 px-16 border-b border-card-border border-opacity-10 flex items-center">
                        <h2 class="text-lg">{{ record.user.full_name_reverse }}</h2>
                    </div>
                    <div
                        class="w-1/4 py-4 px-16 border-b border-l border-card-border border-opacity-10 flex flex-col justify-center"
                    >
                        <h2 class="text-lg" v-text="getProjectName(record)"></h2>
                        <div class="font-light text-xs flex items-center">
                            <span>{{ getRecordCustomerName(record) }}</span>
                        </div>

                        <span
                            class="error-message"
                            v-if="validationErrors['work_hours.' + index]"
                            v-text="validationErrors['work_hours.' + index][0]"
                        ></span>
                    </div>
                    <div
                        v-if="record.leave == 'WORK'"
                        class="flex flex-col flex-grow border-b border-l border-card-border border-opacity-10"
                    >
                        <div class="w-full h-full flex justify-center items-start">
                            <div class="time-cell w-1/4">{{ record.date }}</div>
                            <div @click="showEditForm(record, index)" class="time-cell editable">
                                <span>{{ formatToHours(record.start_time) }}</span>
                                <span v-if="record.edited" class="edited">(ažurirano)</span>
                            </div>
                            <div
                                @click="showEditForm(record, index)"
                                class="time-cell editable border-l border-card-border border-opacity-10"
                            >
                                <span>{{ formatToHours(record.end_time) }}</span>
                                <span v-if="record.edited" class="edited">(ažurirano)</span>
                            </div>
                            <div
                                @click="showEditForm(record, index)"
                                class="time-cell editable border-l border-card-border border-opacity-10"
                            >
                                <!-- <span>{{ calculateDiff(record.start_time, record.end_time) }}</span> -->
                                <span
                                    :class="{
                                    'has-comment': record.remark
                                }"
                                >
                                    {{ record.total_time }}
                                    <img
                                        style="width: 15px; height: 15px;"
                                        v-if="record.remark"
                                        src="/svg/comment.svg"
                                        alt
                                    />
                                </span>

                                <span v-if="record.edited" class="edited">(ažurirano)</span>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        class="flex flex-col flex-grow border-b border-l border-card-border border-opacity-10"
                    >
                        <div class="w-full h-full flex justify-center items-start">
                            <div class="time-cell">{{ record.date }}</div>
                            <div @click="showEditForm(record, index)" class="time-cell editable">
                                <span>-</span>
                                <span v-if="record.edited" class="edited">(ažurirano)</span>
                            </div>
                            <div
                                @click="showEditForm(record, index)"
                                class="time-cell editable border-l border-card-border border-opacity-10"
                            >
                                <span>-</span>
                                <span v-if="record.edited" class="edited">(ažurirano)</span>
                            </div>
                            <div
                                @click="showEditForm(record, index)"
                                class="time-cell editable border-l border-card-border border-opacity-10"
                            >
                                <span
                                    class="text-xs text-white rounded-full px-2"
                                    :class="{
                                        'bg-sick': record.leave == 'SICK',
                                        'bg-free': record.leave == 'FREE',
                                        'bg-vacation': record.leave == 'VACATION',
                                    }"
                                >{{
                                    statusList.find(status => status.name == record.leave) ?
                                    statusList.find(status => status.name == record.leave).display :
                                    '-'
                                }} {{ record.leave == 'SICK' && record.has_work_injury ? ' - Rad' : '' }}
                                </span>
                                <span
                                    :class="{
                                        'has-comment': record.remark
                                    }"
                                >
                                    <img
                                        style="width: 15px; height: 15px;"
                                        v-if="record.remark"
                                        src="/svg/comment.svg"
                                        alt
                                    />
                                </span>

                                <span v-if="record.edited" class="edited">(ažurirano)</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex flex-col justify-center w-32 py-6 px-6 border-b border-l border-card-border border-opacity-10"
                    >
                        <div class="w-full">
                            <div class="form-group form-checkbox items-center">
                                <input
                                    class
                                    type="checkbox"
                                    :name="'confirmed-' + index"
                                    :id="'confirmed-' + index"
                                    v-model="record.confirmed"
                                    :disabled="!!record.is_locked"
                                />
                                <label :for="'confirmed-' + index"></label>
                            </div>
                        </div>
                    </div>
                    <div class="w-16 border-b border-l border-card-border border-opacity-10 flex items-center justify-center">
                        <button @click="showLogModal(record)">Log</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showCard" class="flex justify-end mt-8 mr-8">
            <button
                @click="submitConfirmForm"
                class="btn lg primary text-lg font-bold px-8 py-4 mx-2"
                :disabled="!!monthLocked"
            >Potvrdi sve unose</button>
        </div>

        <response v-if="showResponse" :data="responseData"></response>
    </div>
</template>

<script>
import Modal from "./Modal";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Response from "./Response";

export default {
    components: {
        VueCtkDateTimePicker,
        Modal,
        vSelect,
        Response,
    },

    props: {
        statusList: {
            type: Array,
            default: () => [],
            required: true,
        },
        projectsList: {
            type: Array,
            default: () => [],
            required: true,
        },
        usersList: {
            type: Array,
            default: () => [],
            required: true,
        },
    },

    data() {
        return {
            pickedDate: "",
            validationErrors: {},
            form: {
                record_status: "",
                record: {},
                record_index: "",
                start_time: "",
                end_time: "",
                total_time: "",
                project: "",
                remark: "",
                has_work_injury: false,
            },
            redirectMessage: "",
            showCard: false,
            showEditModal: false,
            workHours: [],
            monthLocked: false,
            showResponse: false,
            responseData: {},
            maxDate: "",
            projectEmptyError: "",
            logModalOpen: false,
            logData: null,
            removeRecordPopup: false,
            isFetchDataFromAPI: false,
            errorMessage: ''
        };
    },

    created() {
        this.maxDate = moment().format("YYYY-MM-DD HH:mm");
    },

    computed: {
        allSelected() {
            let notConfirmed = false;
            _.forEach(this.workHours, (record) => {
                if (!record.confirmed) {
                    notConfirmed = true;
                }
            });

            return notConfirmed;
        },
    },

    methods: {
        descriptionSwitch(description) {
            switch (description) {
                case 'created':
                    return 'Kreiran'
                    break;
                case 'updated':
                    return 'Ažuriran'
                    break;
                default:
                    return '-'
                    break;
            }
        },

        parseDate(date) {
            let newDate = new Date(date)
            let dd = String(newDate.getDate()).padStart(2, '0');
            let mm = String(newDate.getMonth() + 1).padStart(2, '0');
            let yyyy = newDate.getFullYear();

            let H = String(newDate.getHours()).padStart(2, '0');
            let M = String(newDate.getMinutes()).padStart(2, '0');
            let S = String(newDate.getSeconds()).padStart(2, '0');

            return `${dd}.${mm}.${yyyy} ${H}:${M}:${S}`;
        },

        getRecordCustomerName(record) {
            if (record.project) {
                return record.project.customer.name;
            } else {
                return " ";
            }
        },

        getProjectName(record) {
            if (record.project) {
                return record.project.name;
            } else {
                return "-";
            }
        },

        toggleResponse() {
            this.showResponse = true;
            setTimeout(() => {
                this.showResponse = false;
            }, 2000);
        },

        unselectAll() {
            _.forEach(this.workHours, (record) => {
                record.confirmed = false;
            });
        },

        selectAll() {
            _.forEach(this.workHours, (record) => {
                record.confirmed = true;
            });
        },

        handleChosenStatus(e, form = 'edit') {
            if (e != "WORK" && form === 'edit') {
                this.form.start_time = "";
                this.form.end_time = "";
                this.form.total_time = "";
            }
        },

        closeEditForm() {
            this.projectEmptyError = "";
            this.showEditModal = false;
        },

        formatToHours(datetime) {
            if (
                moment(datetime, "YYYY-MM-DD HH:mm:ss").format("HH:mm") == "Invalid date"
            ) {
                return "-";
            }

            return moment(datetime, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
        },

        clearForm() {
            this.form = {
                record_status: "",
                record: {},
                record_index: "",
                start_time: "",
                end_time: "",
                total_time: "",
                remark: "",
                has_work_injury: false,
            };
        },

        showEditForm(record, index) {
            if (record.is_locked) {
                this.errorMessage = 'Mjesec je zaključan za izmjenu trenutnih radnih sati. Kontaktirajte administratora';
                return;
            }
            this.showEditModal = true;
            this.form.record_index = index;
            this.form.record = record;
            this.form.project = record.project;
            this.form.record.start_time = record.start_time
                ? record.start_time
                : record.date;
            this.form.record.end_time = record.end_time
                ? record.end_time
                : record.date;
            this.form.total_time = record.total_time;
            this.form.has_work_injury = record.has_work_injury;
            this.form.record_status = this.statusList.find(
                (status) => status.name == record.leave
            );
        },

        checkRecordStatus() {
            if (this.form.project == null && this.form.record_status.name == 'WORK') {
                this.projectEmptyError = "Potrebno je odabrati radni nalog";
            } else {
                this.projectEmptyError = "";
                this.saveTimeChange();
            }
        },

        toggleRemoveRecordPopup(visible = false) {
          this.removeRecordPopup = visible
        },

        removeRecord() {
            this.showLoader();
            let data = { work_hour: this.form.record.id };
            let formData = new FormData();
            let endpoint = route('work-hours.destroy', data);

            formData.append('_method', 'DELETE');

            axios
                .post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.isFetchDataFromAPI = true;
                        this.fetchData();
                        this.showEditModal = false;
                        this.responseData = response.data.data;
                        this.toggleResponse();

                        this.toggleRemoveRecordPopup(false);
                        this.hideLoader();
                    }
                })
                .catch((error) => {
                    if (typeof error.response !== "undefined") {
                        this.validationErrors = error.response.data.errors;
                    }

                    this.toggleRemoveRecordPopup(false);

                    console.error(error);
                    this.hideLoader();
                });
        },

        saveTimeChange() {
            this.showLoader();
            this.validationErrors = {};

            let formData = new FormData();
            let endpoint = "";

            let data = {
                work_hour: this.form.record.id,
            };

            endpoint = route("work-hours.update", data);

            formData.append("_method", "PATCH");

            if (this.form.record.start_time) {
                formData.append("start_time", this.form.record.start_time);
            } else {
                formData.append("start_time", "");
            }

            if (this.form.record.end_time) {
                formData.append("end_time", this.form.record.end_time);
            } else {
                formData.append("end_time", "");
            }

            if (this.form.record.total_time) {
                formData.append("total_time", this.form.record.total_time);
            } else {
                formData.append("total_time", "");
            }

            if (this.form.record.remark) {
                formData.append("remark", this.form.record.remark);
            } else {
                formData.append("remark", "");
            }

            if (this.form.has_work_injury) {
                formData.append("has_work_injury", 1);
            }

            if (this.form.project) {
              formData.append("project_id", this.form.project.id);
            }

            formData.append("status", this.form.record_status.name);
            formData.append("for_date", this.form.record.date);

            // Send the formData to user controller store/update function depending on endpoint
            axios
                .post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.workHours[this.form.record_index] = response.data.updated_record;
                        this.showEditModal = false;
                        this.responseData = response.data.data;
                        this.toggleResponse();
                        this.hideLoader();
                    }
                })
                .catch((error) => {
                    if (typeof error.response !== "undefined") {
                        this.validationErrors = error.response.data.errors;
                    }

                    console.error(error);
                    this.hideLoader();
                });
        },

        calculateDiff(start_time, end_time) {
            let start = moment(start_time, "YYYY-MM-DD HH:mm:ss");
            let end = moment(end_time, "YYYY-MM-DD HH:mm:ss");
            let dif = end.diff(start);
            var formated = moment.utc(dif).format("HH:mm");

            if (formated == "Invalid date") {
                return "-";
            }

            return formated;
        },
        showDataForDate() {
            this.validationErrors = {};

            if (!this.pickedDate) {
                this.validationErrors = {
                    noDate: ["Odaberite datum"],
                };
            } else {
                this.fetchData();
            }
        },

        fetchData() {
            if (!this.isFetchDataFromAPI) {
                this.showLoader();
            }
            this.validationErrors = {};

            let formData = new FormData();
            let endpoint = "";

            endpoint = route("work-hours.fetch-unconfirmed", { date: this.pickedDate });

            // Send the formData to user controller store/update function depending on endpoint
            axios
                .get(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.workHours = response.data.workHours;
                        this.monthLocked = response.data.is_locked;

                        if (this.workHours[0]) {
                            this.showCard = true;
                        }
                        if (!this.isFetchDataFromAPI) {
                            this.hideLoader();
                        }
                        this.isFetchDataFromAPI = false;
                    }
                })
                .catch((error) => {
                    if (typeof error.response !== "undefined") {
                        this.validationErrors = error.response.data.errors;
                    }

                    console.error(error);
                    if (!this.isFetchDataFromAPI) {
                        this.hideLoader();
                    }
                    this.isFetchDataFromAPI = false;
                });
        },

        // Submit the form
        submitConfirmForm() {
            this.showLoader();
            this.validationErrors = {};

            let formData = new FormData();
            let endpoint = "";

            // Append all form items
            _.forEach(this.workHours, (item, key) => {
                if (item.confirmed) {
                    formData.append("work_hours[" + key + "]", item.id);
                }
            });

            endpoint = route("work-hours.confirm");

            // Send the formData to user controller store/update function depending on endpoint
            axios
                .post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.responseData = response.data.data;
                        this.toggleResponse();
                        this.isFetchDataFromAPI = true;
                        this.fetchData();
                        this.hideLoader();
                    }
                })
                .catch((error) => {
                    if (error.response.data.errors) {
                        this.validationErrors = error.response.data.errors;
                    }

                    console.error(error);
                    this.hideLoader();
                });
        },

        showLogModal(record) {
            this.logModalOpen = true;
            this.logData = record;
            this.logData.activities.reverse()
        },

        hideLogModal() {
            this.logModalOpen = false;
            this.logData = null;
        }
    },
};
</script>
